import React, { useMemo, useState, useRef, useEffect, useCallback, useReducer } from 'react';

import {
	Card,
	TranslatedString,
	useAjax,
	XhrStatus,
	Callout
} from '@bosch/bt-ui';

import './UpdateCompanyPage.css';
import withErrorHandler from '../../../components/ErrorHandler';
import { useParams } from 'react-router-dom';
import PostCompanyForm from '../SettingsComponent/PostCompanyForm';
import CenterLoadingContainer from '../../../components/CenterLoadingContainer';
import RestfulCallout from '../../../components/RestfulCallout';
import RestfulCallLoading from '../../../components/RestfulCallLoading';

const UpdateCompanyPage = (props) => {
	const {
		token,
		setIsDirty
	} = props;

	const {
		companyId = ''
	} = useParams();


	const [result, status, getRpsSettings, response] = useAjax(XhrStatus.InProgress);
	const [updateState] = useState((history && history.state && history.state.usr) || undefined)
	//const [updateState] = useState((history && history.state && history.state.state) || undefined)
	const [shouldDisplay, setDisplay] = useState(!!updateState && !!updateState.updateState.message && updateState.isCreation)


	if(status === 'fulfilled' && !!updateState)
	{
		history.replaceState({}, document.title);
		if(shouldDisplay)
		{
			window.addEventListener('submit', function(e) {
				if(shouldDisplay)
				{
					setDisplay(false)
					window.removeEventListener('submit')
				}
			})
		}
	}
	useEffect(
		() => {
			getRpsSettings('GET', SUPPORTCONSOLE_API_URL + '/api/companymanager/v1/companies/' + encodeURIComponent(companyId) + '/rpscontrols', null, undefined, { 'Authorization': 'Bearer ' + token.token });
		},
		[companyId, token, getRpsSettings]
	);
	
	return (
		<Card
			background="secondary"
			htmlAttributes={{
				id: 'update-company-page',
				className: 'page'
			}}
		>	
			{
				(shouldDisplay &&
				<RestfulCallout status={updateState.status} response={response} returnObj={updateState.updateState} hideSuccess={false} />
				) ||
				<RestfulCallout status={status} response={response} returnObj={result} hideSuccess={true} />
			}
			<div className="page-contents">
			{
				result?.data && 
				< PostCompanyForm token={token} setIsDirty={setIsDirty} result={result.data} companyId={companyId} mode='update' />
			}
			</div>
			<RestfulCallLoading status={status} />
		</Card>
	);
};

export default withErrorHandler(React.memo(UpdateCompanyPage));